import { MainHeading } from "~/src/components/MainHeading"

//region Types
/*
export type DashboardStorefrontInsightsProps = {
  ...
}
*/
//endregion

//region Component
export function DashboardStorefrontInsightsShow() {
  //region Event Handlers
  //endregion

  //region JSX
  return (
    <div className="mx-6 flex flex-col @container">
      <MainHeading title="Storefront Insights" description="TODO" className="ml-0 mr-auto" />
    </div>
  )
  //endregion
}
//endregion

//region Private
//endregion
